'use client'

import { useNavigation } from 'hooks/useNavigation/useNavigation'
import {
	CHECKOUT_AUTHENTICATION_PATHNAME,
	CHECKOUT_DELIVERY_PATHNAME,
	CHECKOUT_GIFT_VOUCHER_PATHNAME,
} from 'links/constants/links'
import { GIFT_VOUCHER_PARAM } from 'links/constants/params'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useSession } from 'session/src/hooks/useSession'
import { env } from 'utils/envManager/envManager'

export const useCheckoutLinks = () => {
	const { logged } = useSession()
	const { navigate } = useNavigation()
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const navigateToCheckout = (isGiftVoucher = false) => {
		const url = new URL(
			`/${countryISO.toLowerCase()}/${languageISO}`,
			env.NEXT_PUBLIC_CURRENT_ORIGIN
		)

		const getCheckoutPathName = () => {
			if (!logged) {
				return CHECKOUT_AUTHENTICATION_PATHNAME
			}
			if (isGiftVoucher) {
				return CHECKOUT_GIFT_VOUCHER_PATHNAME
			}
			return CHECKOUT_DELIVERY_PATHNAME
		}

		url.pathname = `${url.pathname}${getCheckoutPathName()}`
		if (!logged && isGiftVoucher) {
			url.searchParams.set(GIFT_VOUCHER_PARAM, 'true')
		}

		navigate(url.href)
	}

	return { navigateToCheckout }
}
